import { markingsAPI } from 'chessboard/plugins/markings/api';
import { Markings } from 'chessboard/plugins/markings/config/types';
import { match } from 'chessboard/plugins/markings/handlers';

/**
 * Create the markings plugin.
 */
export function createMarkingsPlugin() {
  return {
    api: markingsAPI,
    match,
    name: Markings.Plugin.Name,
  };
}
